"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var cloneWithTooltip = function cloneWithTooltip(tooltip, children) {
  if (!tooltip) return children;
  return /*#__PURE__*/(0, _react.cloneElement)(tooltip, {
    children: children
  });
};

var _default = cloneWithTooltip;
exports.default = _default;